import React, { useEffect, useCallback } from "react";
import { useAnimation, motion, delay } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Typography } from "@material-tailwind/react";
import { useTranslation } from "react-i18next";

const HowStart = () => {
  const { t, i18n } = useTranslation();
  console.log(i18n.language);

  const leftContentControls = useAnimation();
  const { ref: leftContentRef, inView: leftContentInView } = useInView({
    threshold: 0.1,
    triggerOnce: false, // Set to false to allow triggering multiple times
  });

  const timelineControls = useAnimation();
  const { ref: timelineRef, inView: timelineInView } = useInView({
    threshold: 0.1,
    triggerOnce: false, // Set to false to allow triggering multiple times
  });

  useEffect(() => {
    if (leftContentInView) {
      leftContentControls.start("visible");
    } else {
      leftContentControls.start("hidden");
    }
  }, [leftContentInView, leftContentControls]);

  useEffect(() => {
    if (timelineInView) {
      timelineControls.start("visible");
    } else {
      timelineControls.start("hidden");
    }
  }, [timelineInView, timelineControls]);

  const fadeIn = {
    hidden: { opacity: 0, y: 50 },
    visible: (index) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay: index * 0.5 },
    }),
    exit: { opacity: 0, y: 50 },
  };

  const slideUp = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 2, delay: 0.1 },
    },
  };

  const steps = [
    t("start-registration"),
    t("start-login"),
    t("start-search"),
    t("start-review"),
    t("start-enroll"),
    t("start-completion"),
    // t("start-certification"),
  ];

  const renderSteps = useCallback(() => {
    return steps.map((step, index) => (
      <motion.div
        key={index}
        custom={index}
        initial="hidden"
        animate={timelineControls}
        variants={fadeIn}
        className="mb-8 relative flex items-start"
      >
        <div
          className={`w-8 h-8 bg-indigo-600 rounded-full flex items-center justify-center text-white text-xs font-semibold absolute ${i18n.language === "en" ? "left-4 md:-left-4" : "right-4 md:-right-4"}`}
        >
          <span>✓</span>
        </div>
        <div
          className={`${i18n.language === "en" ? "ml-10 pl-6" : "mr-10 pr-6"}`}
        >
          <Typography variant="h6" className="text-indigo-600 mb-1">
            {step.split(": ")[0]}
          </Typography>
          <Typography className="text-gray-700">
            {step.split(": ")[1]}
          </Typography>
        </div>
      </motion.div>
    ));
  }, [timelineControls, steps]);

  return (
    <section className="mt-20 overflow-hidden bg-gray-50 py-10">
      <div className="container px-4 mx-auto sm:max-w-5xl sm:px-6 lg:max-w-7xl lg:px-8">
        <div className="tracking-wide max-w-2xl mb-16">
          {/* <h6 className="tracking-wide leading-relaxed text-indigo-500 text-md">{t("everything-you-need")}</h6> */}
          <h5 className="font-bold text-m lg:text-3xl mt-0 mb-2">
            {t("how-i-started")}
          </h5>
          <p className="leading-relaxed text-md">
            {t("how-to-start-description")}
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <motion.div
            ref={leftContentRef}
            className={`lg:col-span-1 p-4 lg:pl-0 lg:pr-12`}
            initial="hidden"
            animate={leftContentControls}
            variants={slideUp}
          >
            <Typography variant="h4" className="mb-4 text-indigo-600">
              {t("meet-educators")}
            </Typography>
            <Typography className="text-gray-700 mb-6">
              {t("sub-meet-educators")}
            </Typography>
            {/* <Typography variant="h4" className="mb-4 text-indigo-600">
                        {t("certification-excellence")} */}
            {/* </Typography> */}
            {/* <Typography className="text-gray-700 mb-6">
                        {t("sub-certification-excellence")}
                        </Typography> */}
            <Typography variant="h4" className="mb-4 text-indigo-600">
              {t("comprehensive-diverse")}
            </Typography>
            <Typography className="text-gray-700">
              {t("sub-comprehensive-diverse")}
            </Typography>
          </motion.div>

          <motion.div
            ref={timelineRef}
            initial="hidden"
            animate={timelineControls}
            variants={{
              hidden: { opacity: 0 },
              visible: {
                opacity: 1,
                transition: {
                  staggerChildren: 0.5,
                  duration: 0.8,
                },
              },
            }}
          >
            <div className="relative">
              <div
                className={`absolute top-0 ${i18n.language === "en" ? "left-0" : "right-0"} h-full border-0 md:border-l-2 border-indigo-600`}
              ></div>
              {renderSteps()}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HowStart;
